import './App.css';
import { AppContext, Env, context } from './context';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CompleteThreeDS from './views/CompleteThreeDS';
import CardEnrollment from './views/CardEnrollment';
import EnvironmentBadge from './components/EnvironmentBadge/EnvironmentBadge';
import CheckoutCardEntry from './views/CheckoutCardEntry';
import CompleteThreeDSV2 from './views/CompleteThreeDSV2/CompleteThreeDSV2';
import { HelmetProvider } from 'react-helmet-async';
import Head from './components/Head/Head';

function App(): JSX.Element {
  return (
    <HelmetProvider>
      <div className="App">
        <Head apiHost={context.apiUrl} />
        <EnvironmentBadge env={context.env} />
        <AppContext.Provider value={context}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<CardEnrollment />} />
              <Route path="/auth" element={<CompleteThreeDS />} />
              <Route path="/checkout" element={<CheckoutCardEntry />} />
              <Route path="/checkout/auth" element={<CompleteThreeDSV2 />} />
            </Routes>
          </BrowserRouter>
        </AppContext.Provider>
        {context.env === Env.UAT ? <p>{process.env.REACT_APP_GIT_SHA}</p> : <></>}
      </div>
    </HelmetProvider>
  );
}

export default App;
